<template>
  <div>
    <div style="border: 1px solid #ccc; margin-top: 10px">
      <Toolbar style="border-bottom: 1px solid #ccc" :editor="editor" :defaultConfig="toolbarConfig" />
      <Editor style="height: calc(100vh - 180px); overflow-y: hidden" :defaultConfig="editorConfig" v-model="myValue"
        @onChange="onChange" @onCreated="onCreated" />
    </div>
  </div>
</template>
<script>
import { Editor, Toolbar } from "@wangeditor/editor-for-vue";

export default {
  components: { Editor, Toolbar },
  props: {
    value: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      editor: null,
      myValue: this.value,
      toolbarConfig: {
        //toolbarKeys: [ /* 显示哪些菜单，如何排序、分组 */ ],
        //excludeKeys: [ /* 隐藏哪些菜单 */ ],
      },
      editorConfig: {
        placeholder: "请输入内容...",
        // autoFocus: false,
        // 所有的菜单配置，都要在 MENU_CONF 属性下
        MENU_CONF: {
          uploadImage: {
            server: this.$axios.defaults.baseURL + '/Api/Upload?source=edit',
            fieldName: 'your-custom-name',// form-data fieldName ，默认值 'wangeditor-uploaded-image'
            maxFileSize: 100000 * 1024 * 1024,   // 单个文件的最大体积限制，默认为 2M
            maxNumberOfFiles: 10, // 最多可上传几个文件，默认为 100
            allowedFileTypes: ['image/*'], // 选择文件时的类型限制，默认为 ['image/*'] 。如不想限制，则设置为 []
            metaWithUrl: false,// 将 meta 拼接到 url 参数中，默认 false
            headers: { token: localStorage.getItem("token") },
            withCredentials: true, // 跨域是否传递 cookie ，默认为 false
            timeout: 5 * 1000,   // 超时时间，默认为 10 秒
          },
          uploadVideo: {
            server: this.$axios.defaults.baseURL + '/Api/Upload?source=edit',
            timeout: 5 * 1000, // 5s
            fieldName: 'custom-fileName',
            meta: { token: 'xxx', a: 100 },
            metaWithUrl: true, // join params to url
            headers: { token: localStorage.getItem("token") },
            maxFileSize: 100000 * 1024 * 1024, // 100M
          }
        },
      },
    };
  },

  watch: {
    //监听内容变化
    value(newValue) {
      this.myValue = newValue
    },
    myValue(newValue) {
      this.$emit('input', newValue)
    }
  },
  mounted(){
  },
  methods: {
    onCreated(editor) {
      this.editor = Object.seal(editor); // 【注意】一定要用 Object.seal() 否则会报错
      if(this.disabled)this.editor.disable()
    },
    onChange(editor) {
      editor.getHtml()// onChange 时获取编辑器最新内容
    },
  },
  beforeDestroy() {
    const editor = this.editor;
    if (editor == null) return;
    editor.destroy(); // 组件销毁时，及时销毁 editor ，重要！！！
  },
};
</script>
<style src="@wangeditor/editor/dist/css/style.css"></style>
<style>
.el-dialog>.el-dialog__body {
  border-top: 0px solid #e9e9e9;
  border-bottom: 0px solid #e9e9e9;
}
</style>